import { Link } from "@reach/router";
import { Button } from "components/button/Button";
import React from "react";
import Logo from "../../../assets/Logo.png";

const LoginNavBar = () => {
  return (
    <div className="Header WidthContent">
      <Link to="/sign-in">
        <img className="Header__logo" src={Logo} alt=""></img>
      </Link>
      <Link to="/sign-in">
        <Button isPublic priority="primary" type="submit" className="Btn_01">
          Sign in
        </Button>
      </Link>
    </div>
  );
};

export { LoginNavBar };
